var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "appstore",
    "data-name": "appstore",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 224.99 224.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "StoreIcons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.85,0H46.14A46.19,46.19,0,0,0,0,46.14V178.85A46.19,46.19,0,0,0,46.14,225H178.85A46.19,46.19,0,0,0,225,178.85V46.14A46.19,46.19,0,0,0,178.85,0ZM69.28,173.37a11,11,0,0,1-19-11l2.16-3.74H77.78ZM48.56,149.85a11,11,0,0,1,0-22H70.17L99.81,76.54l-8-13.91a11,11,0,0,1,4-15h0a11,11,0,0,1,15,4l1.69,2.93,1.69-2.93a11,11,0,1,1,19,11L95.54,127.88H119.3l12.69,22Zm127.88,0h-8.93l7.23,12.53a11,11,0,1,1-19,11L117.57,107.3l12.69-22,24.57,42.55h21.61a11,11,0,0,1,0,22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/appstore.182a45f245bbc9dd746cdf129690e94d.svg";
export { ForwardRef as ReactComponent };